import React, { useEffect, useState } from "react"
import * as Font from "expo-font"
import { RecoilRoot } from "recoil"
import { enableScreens } from "react-native-screens"
import { LogBox, Text, View } from "react-native"
import * as Notifications from "expo-notifications"
import { NotificationService } from "@Services/Notifications.Service"
import Provider from "@Providers/Providers"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { AppRoot } from "@Screens/Main/AppRoot"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
// import { registerGlobals } from "livekit-client"

import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyC9phEB_gtNPSR65Q0iAm9JYk73MKGestg",
  authDomain: "i-cpts-du-val.firebaseapp.com",
  projectId: "i-cpts-du-val",
  storageBucket: "i-cpts-du-val.appspot.com",
  messagingSenderId: "397389535812",
  appId: "1:397389535812:web:be4165104d0ef57b497a11",
  measurementId: "G-3BPT723BKR"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

async function registerServiceWorker() {
    if ("serviceWorker" in navigator) {
      try {
        const registration = await navigator.serviceWorker.register("./firebase-messaging-sw.js");
        console.log("✅ Service Worker enregistré :", registration);
      } catch (error) {
        console.error("❌ Erreur d'enregistrement du Service Worker :", error);
      }
    }
  }
  

// Create a client
const queryClient = new QueryClient()

LogBox.ignoreLogs([
    "Setting a timer",
    "Constants.deviceId",
    "Constants.installationId ",
    "Constants.linkingUrl",
    "Require cycle",
    "VirtualizedLists should never be nested"
])

LocalStorage.getNotificationStatus().then((notificationStatus) => {
    if (notificationStatus) {
        Notifications.setNotificationHandler({
            handleNotification: async () => ({
                shouldShowAlert: true,
                shouldPlaySound: true,
                shouldSetBadge: false
            })
        })

        LocalStorage.getReminderNotification().then((reminders) => {
            if (reminders && reminders?.length > 0) {
                NotificationService.cancelNotificationSchedule().then((response) => {
                    reminders?.map((reminder) => {
                        // NotificationService.schedulePushNotificationForDate(
                        //     reminder.date,
                        //     reminder.title,
                        //     reminder.body
                        // )
                    })
                })
            }
        })

        NotificationService.enableNotificationListenner()
    } else {
        Notifications.setNotificationHandler({
            handleNotification: async () => ({
                shouldShowAlert: false,
                shouldPlaySound: false,
                shouldSetBadge: false
            })
        })
    }
})

enableScreens()

export default function App() {
    const [fontLoaded, setFontLoaded] = useState(false)

    useEffect(() => {
        registerServiceWorker();
      }, []);
    

    useEffect(() => {
        async function loadFont() {
            await Font.loadAsync({
                BreeSerif: require("./assets/fonts/Bree_Serif/BreeSerif-Regular.ttf"),
                OpenSans: require("./assets/fonts/Open_Sans/static/OpenSans/OpenSans_Medium.ttf"),
                OpenSansRegular: require("./assets/fonts/Open_Sans/static/OpenSans/OpenSans-Regular.ttf"),
                OpenSansLight: require("./assets/fonts/Open_Sans/static/OpenSans/OpenSans-Light.ttf"),
                OpenSansBold: require("./assets/fonts/Open_Sans/static/OpenSans/OpenSans-Bold.ttf"),
                OpenSansSemiBold: require("./assets/fonts/Open_Sans/static/OpenSans/OpenSans-SemiBold.ttf"),
                OpenSansItalic: require("./assets/fonts/Open_Sans/static/OpenSans/OpenSans-Italic.ttf")
            })
            setFontLoaded(true)
        }
        loadFont()
    }, [])

    if (!fontLoaded) {
        return null
    }

    return (
        <RecoilRoot>
            <Provider>
                <QueryClientProvider client={queryClient}>
                    <AppRoot />
                </QueryClientProvider>
            </Provider>
        </RecoilRoot>
    )
}
